// extracted by mini-css-extract-plugin
module.exports = {"add-banner-button":"_3dZhnCaVujXaiY4eufOR","banner":"M79E2qsmpCebJfZ9y1z2"};